
export const classNames = (...arr) => arr.filter(Boolean).join(" ");

export const fmtDate = (ts) => {
    if (!ts) return "";
    const d = new Date(ts * 1000);
    return d.toLocaleString("zh-CN", {
        year: "numeric",
        month: "short",
        day: "numeric",
    });
};

export const secondsToDHMS = (sec) => {
    if (sec <= 0) return "已过期";
    const days = Math.floor(sec / 86400);
    const hours = Math.floor((sec % 86400) / 3600);
    const minutes = Math.floor((sec % 3600) / 60);
    const seconds = Math.floor(sec % 60);
    return `${days}天 ${String(hours).padStart(2, "0")}时 ${String(minutes).padStart(2, "0")}分 ${String(seconds).padStart(2, "0")}秒`;
};
